import axios from 'axios';

import { attachAuthInterceptors } from './authInterceptors';

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: '',
  },
});

attachAuthInterceptors(apiClient);

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (
//       error.response?.status === 403 &&
//       !window.location.pathname.includes('/forbidden')
//     ) {
//       window.history.pushState(null, '', '/forbidden');
//       window.location.reload();
//     }
//     return Promise.reject(error);
//   }
// );

export default apiClient;
